module.exports = __webpack_public_path__ + "static/media/dsr_journey4.7bced0cb.svg";